import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type StrollerIconProps = CreateIconComponentProps;
export const StrollerIcon: React.FC<StrollerIconProps> = ({
  title = 'Stroller',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M11.615 16.163h4.198c3.71 0 5.738-2.09 5.738-5.877v-.98H5.878v.98c0 3.787 2.027 5.877 5.737 5.877Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M13.714 2.449h2.1c3.71 0 5.737 2.09 5.737 5.878v.98h-7.837V2.448Z"
    />
    <circle
      cx="9.306"
      cy="20.571"
      r="1.469"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.6"
    />
    <circle
      cx="18.122"
      cy="20.571"
      r="1.469"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.6"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m10.775 19.102 2.94-2.939M16.6 19.072l-2.419-2.419M1.96 6.368h2.182c.884-.016 1.736.588 1.736 1.406v1.794"
    />
  </CreateIconComponent>
);
